export default "__VITE_ASSET__BnYPb6zm__"